import styled from 'styled-components';
import { media } from 'utils/detection';

export default styled.div`
  ${media.medium`
    margin: 10px 6vw 0 0;
    max-width: 30%;
    float: left;
 `}
`;
